import React from "react";
import CMOInnovationForumForm from "../components/forms/CMOInnovationForumForm";

const CMOInnovationForum: React.FC = () => {
  return (
    <>
      <CMOInnovationForumForm />
    </>
  );
};

export default CMOInnovationForum;
